import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';
import { ActivityLogService } from 'src/app/shared/services/activity-logs-service/activity-logs.service';

@Component({
  selector: 'app-callback-logs',
  templateUrl: './callback-logs.component.html',
  styleUrls: ['./callback-logs.component.css'],
})
export class CallbackLogsComponent {
  callbackLogsTable: any = [];

  loginSessionsTable: any = [];
  totalPage: any;
  totalRecords: any;
  pagination = {
    limit: 10,
  currentPage: 1,
  MERCHANTID: "",
  MOPTYPE: "",
  ACQID: "",
  search: '',
  startDate: '',
  endDate: ''
  };
  private subject: Subject<string> = new Subject();
  searchForm!: FormGroup;
  constructor(
    private loginSessionService: ActivityLogService,
    private fb: FormBuilder
  ) {}
  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  initForm() {
    this.searchForm = this.fb.group({
      search: [''],
      startDate:"",
      // startDate: new FormControl(new Date().toISOString().substring(0, 10)),
      endDate: new FormControl(new Date().toISOString().substring(0, 10)),

      // typeId: ['']
    });
  }

  ngOnInit() {
    this.getAllLogs(this.pagination);
    this.initForm();
    this.subject.pipe(
      debounceTime(1000)
    ).subscribe(searchTextValue => {
      this.searchInput(searchTextValue)
    });
  }
  searchInput(e:any){
console.log("e",e.target.value)
this.pagination.search=e.target.value
console.log("s",this.searchForm.value)
this.pagination.currentPage=1
this.getAllLogs(this.pagination);
  }
  searchApiLogs() {
    console.log(this.searchForm);
    let payload: any = {};
    payload = Object.assign({}, this.searchForm.value);
    // payload.currentPage = this.pagination.currentPage;
    payload.currentPage=1;
    payload.limit = this.pagination.limit;
    this.getAllLogs(payload);
  }
  getAllLogs(pagination: any) {
   
    
    this.loginSessionService.getCallBackLogs(pagination).subscribe({
      next: (response: any) => {
        console.log('Get All api logs ', response.data);
        this.callbackLogsTable = response.data.data;
        this.totalPage = response.data.totalPage;
        this.totalRecords = response.data.totalData;
      },
      error: (error) => {
        console.error('Error  getting state:', error);
      },
      complete: () => {
        console.log('Get request completed');
        // clean-up logic for this
      },
    });
  }

  onKeyUp(event: any) {
    this.subject.next(event);
  }

  nextPage() {
    if (this.pagination.currentPage < this.totalPage) {
      this.pagination.currentPage++;
      this.getAllLogs(this.pagination);
    }
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getAllLogs(this.pagination);
  }

  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getAllLogs(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getAllLogs(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getAllLogs(this.pagination);
  }
}
